import React from "react";
import Modal from "material-ui/Modal";
import Paper from "material-ui/Paper";
import Button from "material-ui/Button";
import Select from "material-ui/Select";
import Input, { InputLabel } from "material-ui/Input";
import Checkbox from "material-ui/Checkbox";
import Icon from "material-ui/Icon";
import Menu, { MenuItem } from "material-ui/Menu";
import {
  FormControl,
  FormControlLabel,
  FormHelperText
} from "material-ui/Form";
import TextField from "material-ui/TextField";
import Grid from "material-ui/Grid";
import Typography from "material-ui/Typography";
import Tabs, { Tab } from "material-ui/Tabs";
import { withStyles } from "material-ui/styles";
import styles from "./styles";
import {
  validateFormData,
  validateTargetData
} from "../../../common/formtool";

import { ModalHeader, ModalContents, ModalFooter } from "../../common/modal";

class NewDeviceSoftware extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editSaving: false,
      errors: {},
      software: {
        id: null,
        deviceupdaterepositoryname: '',
        systemdevicetypename: 'LanTEK IV',
        version: '',
        minimumsystemversion: '',
        isfullsystemupdate: false
      },
      error: null
    };

    this.onChange = this.onChange.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillMount() {
    this.props.reset();
  }
 
  componentWillReceiveProps(nextProps) {
    const { editSaving } = this.state;
    const { software } = nextProps;
    
    if (!editSaving) {
      if (software) {
        this.setState({
          software: { ...software }
        });
        return;
      }
    }

    this.setState({
      software: {
        ...this.state.software
      }
    });
  }

  onChange(e) {
    let software = { ...this.state.software };
    
    if (e.target.name === 'isfullsystemupdate') {
      software.isfullsystemupdate = !software.isfullsystemupdate;
    } 
    else {
      software[e.target.name] = e.target.value;
    }

    let errors = { ...this.state.errors };
    errors = {
      ...errors,
      [e.target.name]: false
    };

    if (e.target.name === "systemdevicetypename") {
      delete errors["validSystemDeviceTypeName"];
    }

    if (e.target.name === "version") {
      delete errors["validVersion"];
    }

    if (e.target.name === "deviceupdaterepositoryname") {
      delete errors["validDeviceUpdateRepositoryName"];
    }
    
    this.setState({ software: software, errors });
  }

  handleClose() {
    this.props.close(false);
  }

  handleSubmit(e) {
    e.preventDefault();
    this.submit();
  }

  submit() {
    let {
      translate,
      mode,
      pager,
      create,
      update
    } = this.props;

    let software = { ...this.state.software };
    
    let validationObj = {
      version: {
        required: translate("formfield_error_general_required")
      },
      systemdevicetypename: {
        required: translate("formfield_error_general_required")
      },
      deviceupdaterepositoryname: {
        required: translate("formfield_error_general_required")
      },
    };

    let errors = validateFormData(
      { 
        ...this.state.software, 
        validVersion: this.state.software.version, 
        validSystemDeviceTypeName: this.state.software.systemdevicetypename,
        validDeviceUpdateRepositoryName: this.state.software.deviceupdaterepositoryname
       },
      validationObj
    );

    const missingFieldName = Object.keys(errors)[0];
    
    if (missingFieldName) {
      const textField = document.getElementsByName(missingFieldName)[0];
      textField && textField.focus();
    }
    
    if (Object.keys(errors).length) {
      this.setState({ errors: errors });
    } else {
      let self = this;
      let version = this.state.software.version;
      
      if (mode === "edit") {
        this.setState(
          {
            editSaving: true
          },
          () => {
            update(this.state.software, pager)
              .then(resp => {
                self.handleClose();
                self.props.removedSelectedRadioCheck();
              })
              .catch(err => {
                if (err.errors === "error_repositoryexists") {
                  self.setState({
                    error: {
                      type: "error_duplicate_software",
                      data: version
                    }
                  });
                }
              });
          }
        );
      } else {
        create(software, pager)
          .then(resp => {
            self.handleClose();
          })
          .catch(err => {
            if (err.errors === "error_repositoryexists") {
              self.setState({
                error: {
                  type: "error_duplicate_software",
                  data: version
                }
              });
            }
          });
      }
    }
  }

  getTitle() {
      if (this.props.mode === "edit") {
        return this.props.translate("edit_software");
      } else {
        return this.props.translate("add_software");
      }
  }
  
  getModalError(error) {
    const { translate, classes } = this.props;
    if (error.type === "error_duplicate_software") {
      return (
        <div className={classes.error}>
          <Typography type="subheading" color="inherit">
            {translate("error_duplicate_software")}
          </Typography>
        </div>
      );
    }
  }
  
  render() {
    const {
      classes,
      languages,
      container,
      modal,
      mode,
      translate,
      deviceTypes,
      allRepositories,
      minimumVersions
    } = this.props;

    const {
      software,
      errors,
      error
    } = this.state;

    if (software && (software.isfullsystemupdate === 'False' || software.isfullsystemupdate === 'false' || !software.isfullsystemupdate)) {
      software.isfullsystemupdate = false;
    } else {
      software.isfullsystemupdate = true;
    }

    return (
      <Modal open={modal} onClose={this.handleClose}>
        <div className={classes.root}>
        <form noValidate autoComplete="off" className={classes.form}>
          <Paper className={classes.modal}>
            <ModalHeader>
              <Grid
                container
                alignItems="center"
                direction="row"
                justify="flex-start"
              >
                <Grid item>
                  <Typography
                    type="headline"
                    color="inherit"
                    className={classes.modalHeader}
                  >
                    {this.getTitle()}
                  </Typography>
                </Grid>
              </Grid>
              <Button className={classes.close} onClick={this.handleClose}>
                <Icon>clear</Icon>
              </Button>
            </ModalHeader>

            <ModalContents>
              {error && this.getModalError(error)}
                {(
                  <div>
                    <FormControl className={classes.textField} margin="normal" error={errors.deviceupdaterepositoryname}>
                    <InputLabel required>Device Update Repository</InputLabel>
                    <Select
                      className={classes.deviceType}
                      value={software.deviceupdaterepositoryname}
                      onChange={e => this.onChange(e)}
                      input={
                      <Input
                        name="deviceupdaterepositoryname"
                        id="deviceupdaterepositoryname"
                        value={software.deviceupdaterepositoryname}
                      />
                      }
                    >
                    {allRepositories
                      ? allRepositories.map((repo, index) => {
                          return (
                            <MenuItem key={index} value={repo.name}>
                              {repo.name}
                            </MenuItem>
                          );
                        })
                      : null}
                  </Select>
                  <FormHelperText>Set the repository</FormHelperText>
                  <TextField
                      error={errors.version || errors.validVersion}
                      className={classes.deviceType}
                      required
                      name="version"
                      label="Software Version"
                      margin="normal"
                      value={software.version}
                      onChange={this.onChange}
                      helperText="Please enter the software version in format X.Y.Z-B"
                      inputProps={{
                        maxLength: 10
                      }}
                    />
                </FormControl>
                <FormControl className={classes.textField} margin="normal" error={errors.systemdevicetypename}>
                    <InputLabel required>Device Type</InputLabel>
                    <Select
                      className={classes.deviceType}
                      value={software.systemdevicetypename}
                      onChange={e => this.onChange(e)}
                      input={
                      <Input
                        name="systemdevicetypename"
                        id="systemdevicetypename"
                        value={software.systemdevicetypename}
                      />
                      }
                    >
                    {deviceTypes
                      ? deviceTypes.map((device, index) => {
                          return (
                            <MenuItem key={index} value={device.id}>
                              {device.id}
                            </MenuItem>
                          );
                        })
                      : null}
                  </Select>
                  <FormHelperText>Please select device type</FormHelperText>
              </FormControl>
              <FormControl className={classes.textField} margin="normal">
                    <InputLabel>Minimal System Version Required</InputLabel>
                    <Select
                      className={classes.deviceType}
                      value={software.minimumsystemversion}
                      onChange={e => this.onChange(e)}
                      input={
                      <Input
                        name="minimumsystemversion"
                        id="minimumsystemversion"
                        value={software.minimumsystemversion}
                      />
                      }
                    >
                    {minimumVersions
                      ? minimumVersions.map((version, index) => {
                          if (version.device === software.systemdevicetypename && version.repo === software.deviceupdaterepositoryname) {
                            return (
                              <MenuItem key={index} value={version.version}>
                                {version.version}
                              </MenuItem>
                            );
                          }
                        })
                      : null}
                  </Select>
                  <FormHelperText>Please select minimal system version required</FormHelperText>
              </FormControl>
              <FormControlLabel
                    control={
                      <Checkbox
                        checked={software.isfullsystemupdate}
                        onChange={e => this.onChange(e)}
                        name="isfullsystemupdate"
                        color="primary"
                      />
                    }
                    label={translate("isfullsystemupdate")}
                  />
          </div>
                )}
             
            </ModalContents>

            <ModalFooter>
              {(
                <Button
                  raised
                  color="primary"
                  className={classes.submit}
                  onClick={this.handleSubmit}
                  type="submit"
                >
                  {translate("general_submit")}
                </Button>
              )}
            </ModalFooter>
          </Paper>
          </form>
        </div>
      </Modal>
    );
  }
}

export default withStyles(styles)(NewDeviceSoftware);
